import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
import brands from "../src/Json/Brand.json";
function LibasMenuBags({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");
  const designersSection = [
    {
      name: "Louis Vuitton",
    },
    {
      name: "Gucci",
    },
    {
      name: "Valentino Garavani",
    },
    {
      name: "Chanel",
    },
    {
      name: "Dior",
    },
    {
      name: "Prada",
    },
    {
      name: "Celine",
    },
    {
      name: "Bottega Veneta",
    },
    {
      name: "Saint Laurent",
    },
    {
      name: "Fendi",
    },
    {
      name: "Balenciaga",
    },
    {
      name: "Dolce & Gabanna",
    },
    {
      name: "Michael Kors",
    },
    {
      name: "Marc Jacobs",
    },
    {
      name: "Hermès",
    },
  ];
  const ModelSection = [
    {
      id: "MVj5ICVly4QldEU7TYAU",
      name: "The Birkin",
      nameAr: "بيركين",
    },
    {
      id: "47iinxFNBl51mdw5IDHl",
      name: "The Dionysus",
      nameAr: "ديونيسوس",
    },
    {
      id: "pH8ZCG1ETWR7qPyCEZbq",
      name: "The Jackie 1961",
      nameAr: "جاكي ١٩٦١",
    },
    {
      id: "77VRTOSaGn4SOVuUdFtR",
      name: "The Marmont",
      nameAr: "مارمون",
    },
    {
      id: "ZWtwCjCCf9QAVFyFt8fe",
      name: "The Neverfull",
      nameAr: "نيفيرفل",
    },
    {
      id: "OZ6ZiUTwTOuFbhJxfEPN",
      name: "The LV Pochette Accessoire",
      nameAr: "لويس فيتون بوشيت اكسسوار",
    },
    // {
    //   id: "The Saddle",
    //   brand: "Dior",
    //   name: "The Dior Saddle",
    //   nameAr: "ديور سادل",
    // },
    {
      id: "UaiVnUFP1SFQa1qRISj7",
      name: "The LV Speedy",
      nameAr: "لويس فيتون سبيدي",
    },
    {
      id: "sD0lI9IiRqEhFkYGIwvK",
      name: "The Lady Dior",
      nameAr: "لايدي ديور",
    },
    {
      brand: "Fendi",
      id: "D4sruXCR06IeS7ayMykg",
      name: "The Fendi Baguette",
      nameAr: "فندي باغيت",
    },
    {
      id: "Buxy7ATpMUkQEImE9hsp",
      name: "The Kelly",
      nameAr: "كيلي",
    },
    {
      id: "7eJVq0Qf9ynfJ7I9V0bI",
      name: "The Boy Bag",
      nameAr: "شنطة بوي",
    },

    {
      id: "fPFDIyHOCkF6ECybKbOv",
      name: "The Phantom",
      nameAr: "شنطة بوي",
    },
    {
      id: "qS1mNFjrSrukO9v1joQy",
      name: "The City",
      nameAr: "سيتى",
    },

    {
      id: "3BNZhqSdTwQFeQsd0SDj",
      name: "The Sac Du Jour",
      nameAr: "ساك دو جور",
    },
    {
      id: "5rFS01r1zcy3uo5pSJoC",
      name: "The Triomphe",
      nameAr: "تريومف",
    },
  ];
  const bagswomen = [
    { name: "Handbags", nameAr: "حقائب يد" },
    { name: "Crossbody bags", nameAr: "حقائب كروس" },
    { name: "Shoulder bags", nameAr: "حقائب كتف" },
    { name: "Tote bags", nameAr: "حقائب توت" },
    { name: "Clutch bags", nameAr: "حقائب صغيرة" },
    { name: "Travel bags", nameAr: "حقائب سفر" },
    { name: "Backpacks", nameAr: "حقائب ظهر" },
  ];

  const BagsMen = [
    {
      id: "pA6VrVYknSqqte0biIaR",
      name: "Bags",
    },
    {
      id: "tjVkKS7xYRxBJKXdB1hI",
      name: "Backpacks",
    },
    {
      id: "H5kq3freQ5aGasd3JVE1",
      name: "Belt bags",
    },
    {
      id: "bSDphwJfLG35T3uBUCmx",
      name: "Travel bags",
    },
  ];

  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* {t("Bags")} */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("bagsmain")}
          style={{
            borderBottom:
              expandedCategory === "bagsmain" ? "none" : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "bagsmain" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "bagsmain" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?id=AqFLulu9y2m4mqEIkch1"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "bags") {
                setHide(true);
                return;
              } else {
                setActiveFilter("bags");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "bagsmain" ? "500" : "400",
                textDecoration:
                  expandedCategory === "bagsmain" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Bags")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "bagsmain" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "bagsmain" ? menudown : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "bagsmain" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of designers */}
                  <ul className="list-unstyled">
                    {/*   designers with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&`}
                          className="subtitlemega "
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{
                              marginLeft: "15px",
                            }}
                            onClick={() =>
                              navigateToCategory("mens", "clothes")
                            }
                          >
                            {t("Designers")}
                          </motion.button>
                        </Link>
                        {/* Animated arrow for subcategory */}
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("designersvintage");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.designersvintage
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.designersvintage
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>
                      {/* Nested menu for designersbags */}
                      <AnimatePresence>
                        {expandedSubcategories?.designersvintage && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {designersSection?.map((brandsection) => (
                              <React.Fragment key={brandsection?.name}>
                                {brands
                                  ?.filter(
                                    (brand) => brand?.name === brandsection.name
                                  )
                                  ?.map((brand) => (
                                    <Link
                                      key={brand.id}
                                      to={`/products?id=AqFLulu9y2m4mqEIkch1&brand=${brand.id}`}
                                      className="subtitlemega"
                                      onClick={() => {
                                        if (activeFilter === "bags") {
                                          setHide(true);
                                          return;
                                        } else {
                                          setActiveFilter("bags");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      <motion.li
                                        className="py-1"
                                        variants={nestedItemVariants}
                                      >
                                        <motion.button
                                          className="btn btn-link text-decoration-none p-0 text-dark small"
                                          whileHover={{ x: 3, color: "#000" }}
                                          onClick={() =>
                                            navigateToCategory(
                                              "bags",
                                              "brands",
                                              brand.slug ||
                                                brand.name.toLowerCase()
                                            )
                                          }
                                        >
                                          {i18n.language === "en"
                                            ? brand.name
                                            : brand.nameAr}
                                        </motion.button>
                                      </motion.li>
                                    </Link>
                                  ))}
                              </React.Fragment>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/*   timelessmodels with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            {t("Timeless Models")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("timlessmodeels");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.timlessmodeels
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.timlessmodeels
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for timelessmodels */}
                      <AnimatePresence>
                        {expandedSubcategories?.timlessmodeels && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {/* timeless modeels */}
                            {ModelSection?.map((model) => (
                              <Link
                                key={model?.id}
                                to={`/products?model=${model?.id}`}
                                className="subtitlemega"
                                onClick={() => {
                                  if (activeFilter === "bags") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("bags");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <motion.li
                                  className="py-1"
                                  variants={nestedItemVariants}
                                >
                                  <motion.button
                                    className="btn btn-link text-decoration-none p-0 text-dark small"
                                    whileHover={{ x: 3, color: "#000" }}
                                    onClick={() =>
                                      navigateToCategory(
                                        "bags",
                                        "models",
                                        model.slug || model.name.toLowerCase()
                                      )
                                    }
                                  >
                                    {i18n.language === "en"
                                      ? model.name
                                      : model.nameAr}
                                  </motion.button>
                                </motion.li>
                              </Link>
                            ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* womens with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            Women's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("womensbagss");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.womensbagss ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.womensbagss
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for mens-vinatge */}
                      <AnimatePresence>
                        {expandedSubcategories?.womensbagss && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {SubCategory?.filter(
                              (subcat) =>
                                subcat?.idTypeCategory ===
                                  "AqFLulu9y2m4mqEIkch1" &&
                                bagswomen?.some(
                                  (bag) => bag.name === subcat.name
                                )
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <Link
                                  key={sub.id}
                                  to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "bags") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("bags");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "bags",
                                          "subcategory",
                                          sub.slug || sub.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                    {/* mens with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            Men's
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("mensbagss");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.mensbagss ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.mensbagss
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for mens-bags */}
                      <AnimatePresence>
                        {expandedSubcategories?.mensbagss && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {BagsMen?.map((bags) =>
                              SubCategory?.filter(
                                (subcat) =>
                                  subcat?.name === bags?.name &&
                                  subcat.idTypeCategory ===
                                    "AqFLulu9y2m4mqEIkch1"
                              )?.map((sub) => (
                                <Link
                                  key={sub.id}
                                  to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "bags") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("bags");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "bags",
                                          "subcategory",
                                          sub?.slug || sub?.name?.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuBags;
